<div class="container">
  <qrcode 
  #qrcode 
  [qrdata]="qrdata()" 
  [width]="100" 
  [errorCorrectionLevel]="'M'" 
  [elementType]="'canvas'"
  [margin]="1"
  [class.none]="!withPreview()"
  >
  <!-- imageSrc="assets/images/common/company_logo.png" // TODO: ATTACH WITH UPDATED COMPANY LOGO -->
  </qrcode>
  <canvas #fullCanvas style="display: none;"></canvas>
  <canvas #displayCanvas class="display-canvas" style="display: none;"></canvas>
</div>